(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cn-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var SPEED = 50; /* pixels par seconde, identique partout */

    function setup(root) {
      if (reduce || root.dataset.cnCarouselReady) return;
      var track = root.querySelector('.cn-carousel__track');
      if (!track) return;
      var slides = Array.prototype.slice.call(track.querySelectorAll('.cn-carousel__slide'));
      if (slides.length < 2) return;
      root.dataset.cnCarouselReady = '1';

      /* Copie de la série pour que le défilement boucle sans saut */
      slides.forEach(function (slide) {
        var copy = slide.cloneNode(true);
        copy.setAttribute('aria-hidden', 'true');
        copy.removeAttribute('data-shopify-editor-block');
        Array.prototype.forEach.call(copy.querySelectorAll('a'), function (link) { link.tabIndex = -1; });
        track.appendChild(copy);
      });
      root.setAttribute('data-cn-carousel-running', '');

      var pos = track.scrollLeft;
      var lastRead = pos;
      var last = null;
      var touching = false;
      var visible = true;

      function release() { touching = false; }
      track.addEventListener('pointerdown', function () { touching = true; }, { passive: true });
      track.addEventListener('touchstart', function () { touching = true; }, { passive: true });
      ['pointerup', 'pointercancel', 'touchend', 'touchcancel'].forEach(function (name) {
        window.addEventListener(name, release, { passive: true });
      });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (entries) { visible = entries[0].isIntersecting; }).observe(root);
      }

      function frame(time) {
        var dt = last === null ? 0 : Math.min(time - last, 64);
        last = time;
        if (!visible || document.hidden) {
          requestAnimationFrame(frame);
          return;
        }
        /* Si la position a été changée par la personne (doigt, flèches, molette), on repart de là */
        if (touching || Math.abs(track.scrollLeft - lastRead) > 1.5) {
          pos = track.scrollLeft;
          lastRead = pos;
          requestAnimationFrame(frame);
          return;
        }
        var half = slides.length ? track.children[slides.length].offsetLeft - track.children[0].offsetLeft : 0;
        pos += (SPEED * dt) / 1000;
        if (half > 0 && pos >= half) pos -= half;
        track.scrollLeft = pos;
        lastRead = track.scrollLeft;
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);
    }

    function init() { document.querySelectorAll('[data-cn-carousel-autoplay]').forEach(setup); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
    else init();
    document.addEventListener('shopify:section:load', init);
  })();

  document.addEventListener('click', (event) => {
    const button = event.target.closest('[data-cn-carousel-nav]');
    if (!button) return;
    const track = button.closest('[data-cn-carousel]').querySelector('.cn-carousel__track');
    const slide = track.querySelector('.cn-carousel__slide');
    const step = slide ? slide.getBoundingClientRect().width + 8 : track.clientWidth;
    track.scrollBy({ left: step * Number(button.dataset.cnCarouselNav), behavior: 'smooth' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
